import { usePaymentErrorStaticModel } from '@entities/payment/hooks'
import { PaymentActionState } from '@features/payment/model'

export type HandlePaymentQueue = (paymentState: PaymentActionState) => Promise<void>

type UsePaymentQueueProps = {
  handleEnabledPolling: (merchantUid: string) => void
}

/**
 * 결제 완료 후 polling을 시작하는 훅
 *
 * 이전에는 BFF의 결제 큐 API를 호출했으나,
 * 이제 포트원 웹훅이 백엔드로 직접 전달되므로
 * polling만 활성화합니다.
 */
export const usePaymentQueue = ({ handleEnabledPolling }: UsePaymentQueueProps): HandlePaymentQueue => {
  const { ERROR_MESSAGES } = usePaymentErrorStaticModel()

  return async (paymentState: PaymentActionState) => {
    if (paymentState.status === 'pending') {
      handleEnabledPolling(paymentState.merchantUid)
      return
    }
    if (paymentState.status !== 'success') {
      throw new Error(ERROR_MESSAGES.PAYMENT_FAILED)
    }

    // 웹훅이 백엔드로 직접 전달되므로 polling만 시작
    handleEnabledPolling(paymentState.data.merchantUid)
  }
}
